import React from 'react';

import { Step } from '@vlabs/uikit';
import cn from 'classnames';

import st from './shared.module.sass';
import { FaceOcclusionSubForm } from '../../../forms';

function StepFaceOcclusion() {
  return (
    <Step
      className={cn(st.Step, st.FoldedStep)}
      withPadding={false}
    >
      <FaceOcclusionSubForm />
    </Step>
  );
}

StepFaceOcclusion.fieldNames = [
  'estimate_face_occlusion',
  'filters',
];

export { StepFaceOcclusion };
